import React, { useContext } from 'react';
import { Spin } from 'antd';
import { VibrantPlanningEngineSection } from 'components/molecules/PlanningEngineSection';
import { HomeStyledCardWrapper } from 'components/molecules/common/AlertAndNotificationCard';
import { FilterContextData } from 'contexts/FilterContext';
import PerformanceSummaryCard from 'components/molecules/common/PerformanceSummaryCard';
import JumpBackInCard from 'components/molecules/common/JumpBackInCard';
import AskAsperRibbonHome from 'components/molecules/AskAsperRibbonHome';
import { AIDecisionHub } from 'components/molecules/common/AIDecisionHub';

const HomeNew = () => {
    const { isProfileSwitching } = useContext(FilterContextData);

    return (
        <main className="flex-1 overflow-y-auto relative" style={{ background: 'var(--gradient-vibrant-background)' }}>
            {isProfileSwitching && (
                <div className="absolute inset-0 bg-white bg-opacity-75 backdrop-blur-sm z-50 flex items-center justify-center">
                    <Spin size="large" tip="Switching profile..." />
                </div>
            )}
            <section className="container px-6 pt-6 pb-8">
                <div className="text-center space-y-3 mb-4">
                    <h1 className="text-5xl md:text-6xl font-light tracking-tight mb-0">
                        Welcome to{' '}
                        <span
                            className="font-bold bg-clip-text text-transparent"
                            style={{ backgroundImage: 'var(--gradient-title)' }}
                        >
                            Asper RGM
                        </span>
                    </h1>
                    <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
                        Your centralized hub for all RGM tools and insights
                    </p>
                </div>
            </section>
            <section className="container max-w-[1600px] mx-auto px-6 pt-4 pb-2">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <HomeStyledCardWrapper bordered={false} className="w-full">
                        <PerformanceSummaryCard />
                    </HomeStyledCardWrapper>
                    <HomeStyledCardWrapper bordered={false} className="w-full">
                        <JumpBackInCard />
                    </HomeStyledCardWrapper>
                </div>
            </section>
            <section className="container max-w-[1600px] mx-auto px-6 py-4">
                <AskAsperRibbonHome />
            </section>
            <section className="container max-w-[1600px] px-6 py-8">
                <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-4">
                    <VibrantPlanningEngineSection />
                    <AIDecisionHub />
                </div>
            </section>
        </main>
    );
};

export default HomeNew;
